/*
  Cassili-home — chargement du catalogue du configurateur Gallery Wall. v4.3 (13-10-2026)
  Chargé AVANT gwb-next.js / gwb-v3.js.

  Le configurateur appelle /collections/.../products.json une seule fois (sans page=).
  Ce script intercepte uniquement cette requête et charge le catalogue complet :
  - pages de 100 produits, 4 requêtes au plus en même temps (mesuré sur Chrome desktop :
    3 pages de 250 en série = 4,1 à 8,1 s ; 8 pages de 100 en parallèle = 1,3 à 2,2 s) ;
  - les pages sont réassemblées dans l'ordre de leur numéro, jamais dans l'ordre d'arrivée ;
  - la pagination s'arrête à la première page incomplète ; les pages au-delà sont ignorées ;
  - une page en échec est réessayée seule (2 nouvelles tentatives, 0,8 puis 1,6 s) ;
  - si une page échoue définitivement, la requête entière échoue : jamais de catalogue
    partiel présenté comme complet.
  Toute autre requête fetch passe sans être touchée.
*/
(function () {
  if (typeof window.fetch !== 'function') return;

  var TARGET = 'products.json';
  var PAGE_SIZE = 100;
  var CONCURRENCY = 4;
  var MAX_PAGES = 40;
  var RETRY_DELAYS = [800, 1600];
  var nativeFetch = window.fetch.bind(window);

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function fetchPage(base, page, attempt) {
    attempt = attempt || 0;
    return nativeFetch(base + '?limit=' + PAGE_SIZE + '&page=' + page, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) { return (data && data.products) || []; })
      .catch(function (err) {
        if (attempt >= RETRY_DELAYS.length) throw err;
        return wait(RETRY_DELAYS[attempt]).then(function () { return fetchPage(base, page, attempt + 1); });
      });
  }

  function loadAll(base) {
    var pages = {};      // numéro de page -> produits
    var lastPage = null; // première page incomplète rencontrée
    var next = 1;

    function worker() {
      if (lastPage !== null && next > lastPage) return Promise.resolve();
      if (next > MAX_PAGES) return Promise.resolve();
      var page = next++;
      return fetchPage(base, page).then(function (batch) {
        pages[page] = batch;
        if (batch.length < PAGE_SIZE && (lastPage === null || page < lastPage)) lastPage = page;
        return worker();
      }, function () {
        // échec définitif : noté, vérifié à l'assemblage (une page au-delà de la dernière est sans effet)
        pages[page] = null;
        return worker();
      });
    }

    var workers = [];
    for (var i = 0; i < CONCURRENCY; i++) workers.push(worker());
    return Promise.all(workers).then(function () {
      var end = lastPage !== null ? lastPage : MAX_PAGES;
      var all = [];
      for (var p = 1; p <= end; p++) {
        if (!pages[p]) throw new Error('page manquante ou en échec : ' + p);
        all = all.concat(pages[p]);
      }
      return all;
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var concerne = url.indexOf(TARGET) !== -1
      && url.indexOf('/collections/') !== -1
      && url.indexOf('page=') === -1;
    if (!concerne) return nativeFetch(input, init);

    var base = url.split('?')[0];
    var t0 = Date.now();
    return loadAll(base).then(function (all) {
      window.__gwbCatalog = { products: all.length, ms: Date.now() - t0 };
      var payload = { products: all };
      // Réponse minimale : le configurateur n'utilise que ok et json(). Évite de
      // re-sérialiser puis re-parser ~8 Mo de JSON.
      return {
        ok: true,
        status: 200,
        json: function () { return Promise.resolve(payload); },
        text: function () { return Promise.resolve(JSON.stringify(payload)); },
        clone: function () { return this; }
      };
    });
  };
})();
